<app-pan-chip class="plan-chip" [ngClass]="[planClass()]">
  {{ label() | titlecase }}
</app-pan-chip>
